import React,{forwardRef} from 'react'
import "./howitWork.css";
import { useTranslation } from "react-i18next";

const HowitWork =  forwardRef((props, ref)=> {
  const { t } = useTranslation();

  return (
    <div ref={ref}>
        <section className="how-it-works py-5">
            <div className="container">
                <div className="row howitwrk-col py-md-5 rounded-5 mx-md-5 px-md-4 justify-content-center">
                    <div className="col-12 col-md-12 px-md-2">
                     <h2 className='text-center display-6 fw-semibold mb-2 py-3 py-md-1'>{t("HiwHeader")}</h2> 
                    </div>
                    <div className="col-12 col-md-3 col-lg-4  px-3">
                      <div className="text-center mb-0 mt-md-4 pt-md-4 pb-md-3">
                       
                        <img loading="lazy" className='start-0 bottom-0 img-fluid' src="/images/submit-device.png" alt="" height="170" width="250" />
                      </div>
                      <div className='py-1 ps-md-4 d-flex align-items-start gap-2'>
                       <div>
                        <h3 className="fw-semibold text-center fs-5">Submit device information</h3>
                        <p className='text-justify small-font word-spacing-5 pt-3'>Select your device model and carrier, then enter your unique IMEI number to initiate the unlocking process. This step is key to ensuring a customized unlock for your specific device.</p>
                        </div>
                      </div> 
                    </div>
                    
                    <div className="col-12 col-md-3 col-lg-4 px-3">
                      <div className="text-center mb-md-3 mt-3 pb-4">
                       
                        <img loading="lazy" className=' start-0 bottom-0 img-fluid' src="/images/submit-device2.png" alt="" height="170" width="250" />
                      </div>
                      <div className='py-1 ps-md-4 d-flex align-items-start gap-2'>
                       <div>
                        <h3 className="fw-semibold text-center fs-5">Unlocking in progress</h3>
                        <p className='text-justify small-font word-spacing-5 pt-3'>Once you complete your order, we'll start unlocking your device remotely. Stay updated with our real-time tracking system, providing you with continuous progress reports.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 col-lg-4 px-3">
                      <div className=" text-center mb-md-3 mt-5">
                       
                        <img loading="lazy" className='start-0 bottom-0 img-fluid' src="/images/submit-device3.png" alt="" height="170" width="250" />
                      </div>
                      <div className='py-1 ps-md-4 d-flex align-items-start gap-2'>
                       <div>
                        <h3 className="fw-semibold text-center fs-5">Unlock completed</h3>
                        <p className="text-justify small-font word-spacing-5 pt-3">You will receive an email notification when your iPhone is fully unlocked. For Android devices, you will receive the unlock codes requested by your device. Your device will be ready to use on any network </p>
                        </div>
                      </div>
                    </div>
                    
                </div>
            </div>
        </section>
    </div>
  )
})

export default HowitWork;